export const getLatLngData = (value) => {
  return {
    type: 'GET_LAT_LNG',
    payload: value,
  };
};
export const resetLatLngData = (value) => {
  return {
    type: 'GET_LAT_LNG_RESET',
    payload: value,
  };
};
